/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const { project } = feature;
    const MQTT_INTERFACE = 'current_interface';
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const MQTT_NAME = feature.getSettingValue('MQTT_NAME');
    const MQTT_PASSWORD = feature.getSettingValue('MQTT_PASSWORD');
    const MQTT_APP_CLIENT_ID = feature.getSettingValue('MQTT_APP_CLIENT_ID');
    const MQTT_SERVER_HOST = feature.getSettingValue('MQTT_SERVER_HOST');
    const MQTT_DESTINATION_PORT = feature.getSettingValue('MQTT_DESTINATION_PORT');
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    const TOPICS = feature.getSettingValue('TOPICS');

    for (let i = 0; i < TOPICS.length; i++) {
        const topic = TOPICS[i];
        blocks = blocks.concat(topic.getCodeBlocks());
    }

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
mqtt_broker_hostname = ${MQTT_SERVER_HOST};
mqtt_broker_port = ${MQTT_DESTINATION_PORT};

mqtt_client_id=${MQTT_APP_CLIENT_ID};
mqtt_username=${MQTT_NAME};
mqtt_password=${MQTT_PASSWORD};

app_mqtt_init(&mqtt_client_ctx);
mqtt_client_ctx.evt_cb = mqtt_client_event_handler;
        `,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
struct k_work_delayable mqtt_publish_work;
struct k_work_delayable mqtt_process_work;`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
static void mqtt_work_handler(struct k_work *work)
{
    struct net_if *iface = net_if_get_default();
    if (net_if_is_up(iface))
    {
        app_mqtt_run(&mqtt_client_ctx);
    }
    k_work_reschedule(&mqtt_process_work, K_MSEC(1000));
}

static void mqtt_client_event_handler(struct mqtt_client *const client, const struct mqtt_evt *evt)
{
    mqtt_event_handler(client, evt);
    switch (evt->type) {
    case MQTT_EVT_CONNACK: {
        /****callback_mqtt_connect_ok****/
        }
        break;

    case MQTT_EVT_DISCONNECT:
        
        break;
    case MQTT_EVT_PINGRESP:
        
        break;

    case MQTT_EVT_PUBACK:
        
        break;

    case MQTT_EVT_PUBREC: {
        
        }
        break;

    case MQTT_EVT_PUBREL: {
        
        }
        break;

    case MQTT_EVT_PUBCOMP:
        
        break;

    case MQTT_EVT_SUBACK:
        
        break;

    case MQTT_EVT_PUBLISH: {
        /****callback_mqtt_notif****/
        }
        break;

    default:
        break;
    }
}
`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        template: `
#include "mqtt_client.h"
        `,
    });


    blocks.push({
        location: 'boot_complete',
        blockType: BlockType.CODE,
        template: `
k_work_init_delayable(&mqtt_process_work, mqtt_work_handler);
k_work_reschedule(&mqtt_process_work, K_MSEC(1000));
        `,
    });

    return blocks;
};
